import { useState, useEffect } from "react";
import { SetupStep } from "@/components/SetupProgressTracker";
import { isAuthenticated } from "@/lib/auth";

export function useSetupProgress() {
  const [setupSteps, setSetupSteps] = useState<SetupStep[]>([
    { id: "apns", name: "Configure Apple\nPush Notification Service", completed: false, path: "/settings?category=system" },
    { id: "abm", name: "Setup Apple\nBusiness Manager", completed: false, path: "/settings?category=system" },
    { id: "profiles", name: "Create\nConfiguration Profiles", completed: false, path: "/profiles" },
    { id: "devices", name: "Enroll\nDevices", completed: false, path: "/devices" },
  ]);

  useEffect(() => {
    if (!isAuthenticated()) return;

    const apnsConfigs = localStorage.getItem('patching_apns_configs');
    const abmConfigs = localStorage.getItem('patching_abm_configs');
    const parsedApnsConfigs = apnsConfigs ? JSON.parse(apnsConfigs) : [];
    const parsedAbmConfigs = abmConfigs ? JSON.parse(abmConfigs) : [];
    const deviceData = localStorage.getItem('enrolled_devices');
    const enrolledDevices = deviceData ? JSON.parse(deviceData) : [];
    const profilesData = localStorage.getItem('configuration_profiles');
    const configProfiles = profilesData ? JSON.parse(profilesData) : [];

    setSetupSteps(prev => prev.map(step => {
      if (step.id === 'apns') return { ...step, completed: parsedApnsConfigs.length > 0 };
      if (step.id === 'abm') return { ...step, completed: parsedAbmConfigs.length > 0 };
      if (step.id === 'profiles') return { ...step, completed: configProfiles.length > 0 };
      if (step.id === 'devices') return { ...step, completed: enrolledDevices.length > 0 };
      return step;
    }));
  }, []);

  const updateStepCompletion = (stepId: string, completed: boolean) => {
    setSetupSteps(prev => prev.map(step => step.id === stepId ? { ...step, completed } : step));
  };

  return { setupSteps, updateStepCompletion, isLoading: false, isLoggedIn: isAuthenticated() };
}
